import { defineComponent, inject, onMounted, onUnmounted } from 'vue';
import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import Optinv2 from './Optinv2.class';
import { setupComponent } from '@studyportals/vue-platform';

export default defineComponent({
	setup: () => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if (!store) throw new Error('incentiveV2Store was not provided');
		const component = new Optinv2(store);
		onMounted(component.mounted.bind(component));
		onUnmounted(component.unmount.bind(component));
		return setupComponent(component);
	},
});
